import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import type { ReactNode } from "react";

/**
 * Renders a logout button. Always visible since Kinde auth is always active.
 */
export const LogoutButton = (): ReactNode => {
  const { logout } = useKindeAuth();
  return (
    <button
      type="button"
      className="text-default-400 hover:text-default-600 text-xs underline"
      onClick={() => void logout()}
    >
      Sign out
    </button>
  );
};
